export enum DocumentsManager {
  GET_DOCUMENT_CATEGORIES = "GET_DOCUMENT_CATEGORIES",
  GET_DOCUMENT_CATEGORIES_SUCCESS = "GET_DOCUMENT_CATEGORIES_SUCCESS",
  GET_DOCUMENT_CATEGORIES_FAIL = "GET_DOCUMENT_CATEGORIES_FAIL",

  GET_ENTITY_DATA = "GET_ENTITY_DATA",
  GET_ENTITY_DATA_SUCCESS = "GET_ENTITY_DATA_SUCCESS",
  GET_ENTITY_DATA_FAIL = "GET_ENTITY_DATA_FAIL",

  ASSIGN_TO_CASE = "ASSIGN_TO_CASE",
  ASSIGN_TO_CASE_SUCCESS = "ASSIGN_TO_CASE_SUCCESS",
  ASSIGN_TO_CASE_FAIL = "ASSIGN_TO_CASE_FAIL",

  RESET_ASSIGNED_DOCUMENTS = "RESET_ASSIGNED_DOCUMENTS",
  RESET_ASSIGNED_DOCUMENTS_SUCCESS = "RESET_ASSIGNED_DOCUMENTS_SUCCESS",
  RESET_ASSIGNED_DOCUMENTS_FAIL = "RESET_ASSIGNED_DOCUMENTS_FAIL",
}
